/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailPreview
 */
export interface EmailPreview {
    /**
     * 
     */
    to: string;
    /**
     * 
     */
    subject: string;
    /**
     * 
     */
    html: string;
    /**
     * 
     */
    text: string;
}

/**
 * Check if a given object implements the EmailPreview interface.
 */
export function instanceOfEmailPreview(value: object): value is EmailPreview {
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('html' in value) || value['html'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function EmailPreviewFromJSON(json: any): EmailPreview {
    return EmailPreviewFromJSONTyped(json, false);
}

export function EmailPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailPreview {
    if (json == null) {
        return json;
    }
    return {
        
        'to': json['to'],
        'subject': json['subject'],
        'html': json['html'],
        'text': json['text'],
    };
}

export function EmailPreviewToJSON(json: any): EmailPreview {
    return EmailPreviewToJSONTyped(json, false);
}

export function EmailPreviewToJSONTyped(value?: EmailPreview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'to': value['to'],
        'subject': value['subject'],
        'html': value['html'],
        'text': value['text'],
    };
}

